import type { Breadcrumbs } from "~/core";

export const isPageBreadcrumbs = (item: unknown): item is Breadcrumbs => {
  return (
    typeof item === "object" &&
    item !== null &&
    "__typename" in item &&
    item.__typename === "breadcrumbs"
  );
};
